(function() {
  'use strict';
  angular.module('ringbaPortal').controller('CampaignsController', CampaignsController);

  function CampaignsController(
    _,
    $interval,
    $q,
    $scope,
    $state,
    $location,
    $stateParams,
    $timeout,
    $uibModal,
    $translate,
    accountsService,
    campaignServiceNew,
    columnsFetchService,
    isMobileDevice,
    offersService,
    userSettingsService,
    bsLoadingOverlayService,
    toaster,
    featureFlags,
    utils
  ) {
    'ngInject';

    const vm = this;
    let statsInterval;
    const emptyStats = {
      total: 0,
      currentMonth: 0,
      currentDay: 0,
      currentHour: 0,
      currentLive: 0
    };
    const filterIncludeHidden = {
      'Visible Offers': false,
      'All Offers': true
    };
    const defaultTrWidgetMetadata = {
      title: 'CAMPAIGNS_PAGE_TITLE',
      iconClass: 'typcn typcn-flow-children',
      class: ''
    };
    const wizardTrWidgetMetadata = {
      title: 'CAMPAIGN_WIZARD_STEP_GENERAL_HEADER',
      iconClass: 'fa fa-info-circle',
      class: 'step-1'
    };

    vm.filterOptionsAdminMap = {
      'All': function () {
        return true;
      },
      'Live': function (campaign) {
        return campaign.enabled && campaign.completed;
      },
      'Paused': function (campaign) {
        return !campaign.enabled && campaign.completed;
      },
      'Setup': function (campaign) {
        return !campaign.completed;
      }
    };

    vm.showAllOffers = false;
    vm.columnSettings = campaignServiceNew.columnSettings;
    vm.userSettings = {};
    vm.loading = true;
    vm.offerFilters = Object.keys(filterIncludeHidden);
    vm.offerSelectedFilter = _.findKey(filterIncludeHidden, function(value) {
      return value === false;
    });
    vm.forceUnlink = false;

    vm.$onInit = onInit;
    vm.duplicateCampaign = duplicateCampaign;
    vm.dropSuccess = dropSuccess;
    vm.checkPoolSize = checkPoolSize;
    vm.cancelModal = cancelModal;
    vm.viewReporting = viewReporting;
    vm.countryCodeForCampaign = campaignServiceNew.countryCodeForCampaign;
    vm.confirmArchiveModal = confirmArchiveModal;
    vm.deleteCampaign = deleteCampaign;
    vm.confirmCampaignPause = confirmCampaignPause;
    vm.setCampaignStatus = setCampaignStatus;
    vm.activateCampaignActions = activateCampaignActions;
    vm.showOfferSummary = showOfferSummary;
    vm.cancelSummaryModal = cancelSummaryModal;
    vm.confirmJoinOffer = confirmJoinOffer;
    vm.joinOffer = joinOffer;
    vm.confirmHideOffer = confirmHideOffer;
    vm.hideOffer = hideOffer;
    vm.showOffer = showOffer;
    vm.handleOfferFilterChange = handleOfferFilterChange;
    vm.setForceUnlink = setForceUnlink;
    vm.getRtbStatus = getRtbStatus;
    vm.getRtbStatusToolTip = getRtbStatusToolTip;
    vm.showAddNewForm = showAddNewForm;
    vm.showForm = showForm;
    vm.hideForm = hideForm;

    function onInit() {
      vm.isMobileView = isMobileDevice;
      vm.isAdmin = accountsService.isAdmin();
      vm.isAffiliate = accountsService.isAffiliate();
      vm.isAffiliateManager = accountsService.isAffiliateManager();
      vm.createAccess = accountsService.hasAccess('Campaign', 'CREATE');

      vm.campaignId = ($stateParams.campaignId) ? $stateParams.campaignId : null;
      vm.isWizardRoute = $location.path().includes('campaign-wizard');

      vm.showSpecificRecordDetails = $stateParams.campaignId;
      _setViewDetails(vm.showSpecificRecordDetails);

      _loadUserSettings().then(_loadInitialData);
    }

    function checkPoolSize (campaign) {
      campaign.poolSize = campaign.pool ? campaign.pool.poolSize : 0;
      return campaign.poolSize;
    }

    function dropSuccess (e, item, collection){
      // collection contains the current ordering of columns
      // after the drag and drop. We need to save the
      // collection in user settings under campaigns key
      return userSettingsService.getUserSettings()
        .then(function (userSettings){
          vm.userSettings = userSettings;
          if (!vm.userSettings.campaigns) {
            vm.userSettings.campaigns = {};
          }
          vm.userSettings.campaigns.columns = collection;
          return userSettingsService.saveUserSettings(vm.userSettings);
        });
    }

    function duplicateCampaign(campaignId) {
      if (!vm.formActive) {
        campaignServiceNew.duplicateCampaign(accountsService.currentAccountId, campaignId).then(function (response) {
          $state.go('dashboard.campaign', { campaignId: response.data.campaign.id });
        });
      }
    }

    function viewReporting(campaign) {
      if (vm.formActive) {
        return;
      }

      if (!vm.isAffiliate || (!campaign.offer || (_checkIfUserIsEnrolled(campaign.offer)))) {
        return $state.go('dashboard.call-logs', {
          filterkey: 'campaignName',
          filterdisplay: 'Campaign',
          filtervalue: campaign.name,
          filterisgroup: true
        });
      }
    }

    function confirmArchiveModal(campaign) {
      if (!vm.formActive) {
        vm.campaignToDelete = campaign;
        _checkCampaignReferences(campaign.id);
        vm.keepNumbers = false;
        vm.modal = $uibModal.open({
          templateUrl: '/scripts/components/campaigns/delete-campaign.modal.html',
          scope: $scope,
          controllerAs: 'vm'
        });
      }
    }

    function deleteCampaign() {
      return campaignServiceNew.deleteCampaign(accountsService.currentAccountId, vm.campaignToDelete.id, vm.forceUnlink, vm.keepNumbers).then(function () {
        toaster.pop('success', $translate.instant('CAMPAIGNS_DELETE_SUCCESS'));
        _.remove(vm.currentCampaigns, { id: vm.campaignToDelete.id });
        cancelModal();
      }).catch(utils.errorHandler);
    }

    function confirmCampaignPause(campaign) {
      if (!vm.formActive) {
        vm.campaignToPause = campaign;
        vm.modal = $uibModal.open({
          templateUrl: '/scripts/components/campaigns/pause-campaign.modal.html',
          scope: $scope,
          controllerAs: 'vm'
        });
      }
    }

    function showOfferSummary(campaign) {
      if (!vm.formActive) {
        vm.campaignForOfferSummary = campaign;
        vm.participateActionButtonLabel = $translate.instant(_getParticipateOfferTranslation(campaign.offer, 'CAMPAIGNS_ACTIONS_APPLY_OFFER', 'CAMPAIGNS_ACTIONS_JOIN_OFFER'));
        vm.offerSummaryModal = $uibModal.open({
          templateUrl: '/scripts/components/campaigns/offer-summary.modal.html',
          scope: $scope,
          size: 'lg',
          controllerAs: 'vm'
        });
      }
    }

    function setCampaignStatus(campaign, status) {
      if (!vm.formActive) {
        campaign = campaign || vm.campaignToPause;
        const copyCampaign = angular.copy(campaign);
        copyCampaign.enabled = status;
        return campaignServiceNew.updateCampaign(accountsService.currentAccountId, copyCampaign).then(function () {
          cancelModal();
          campaign.enabled = status;
          campaign.combinedStatus = campaignServiceNew.getCampaignStatus(campaign);
          toaster.pop('success', $translate.instant(status ? 'CAMPAIGNS_ENABLE_SUCCESS' : 'CAMPAIGNS_PAUSE_SUCCESS'));
        }).catch(utils.errorHandler);
      }
    }

    function cancelSummaryModal() {
      if (vm.offerSummaryModal) {
        vm.offerSummaryModal.close();
        vm.offerSummaryModal = null;
        vm.campaignForOfferSummary = null;
      }
    }

    function cancelModal() {
      if (vm.modal) {
        vm.modal.close();
        vm.modal = null;
        vm.campaignToDelete = null;
        vm.campaignToPause = null;
        vm.currentCampaignIdForAction = null;
        vm.offerForActionName = null;
      }
    }

    function activateCampaignActions(campaignId) {
      vm.activeActionCampaignId = vm.activeActionCampaignId == campaignId ? false : campaignId;
    }

    function confirmJoinOffer(campaign) {
      if (_checkIfUserCanParticipate(campaign)) {
        vm.currentCampaignIdForAction = campaign.id;
        vm.offerForActionName = campaign.offer.name;
        vm.joinOfferModalTitle = $translate.instant(_getParticipateOfferTranslation(campaign.offer, 'CONFIRM_APPLY_MODAL_TITLE', 'CONFIRM_JOIN_MODAL_TITLE'), { offerName: vm.offerForActionName });
        vm.modal = $uibModal.open({
          templateUrl: '/scripts/components/campaigns/confirm-join-offer.modal.html',
          scope: $scope,
          size: 'md',
          controllerAs: 'vm'
        });
      }
    }

    function joinOffer(campaignId) {
      return offersService.joinCampaignOffer(accountsService.currentAccountId, campaignId, vm.joinMessage).then(function(response) {
        if (response.data.participationStatus === 'enrolled') {
          toaster.pop('success', $translate.instant('CONFIRM_JOIN_SUCCESS'));
          offersService.initNextSteps(campaignId).finally(function () {
            $state.go('dashboard.campaign', { campaignId: campaignId });
          });
        } else if (response.data.participationStatus === 'pending') {
          const campaign = _.find(vm.currentCampaigns, { id: campaignId });
          if (campaign && campaign.offer) {
            campaign.offer.offerParticipationStatus = response.data.participationStatus;
            campaign.combinedStatus = campaignServiceNew.getCampaignStatus(campaign, vm.isAffiliate);
          }
        }
        cancelModal();
        cancelSummaryModal();
        _hideOfferSummaryIfSameOpen(campaignId);
      }).catch(utils.errorHandler);
    }

    function confirmHideOffer(campaign) {
      if (!vm.formActive) {
        if (_checkIfUserCanParticipate(campaign)) {
          vm.currentCampaignIdForAction = campaign.id;
          vm.offerForActionName = campaign.offer.name;
          vm.hideOfferModalTitle = $translate.instant('CONFIRM_HIDE_MODAL_TITLE', { offerName: vm.offerForActionName });
          vm.modal = $uibModal.open({
            templateUrl: '/scripts/components/campaigns/confirm-hide-offer.modal.html',
            scope: $scope,
            controllerAs: 'vm'
          });
        }
      }
    }

    function hideOffer(campaignId) {
      return offersService.hideCampaignOffer(accountsService.currentAccountId, campaignId).then(function() {
        toaster.pop('success', $translate.instant('CONFIRM_HIDE_SUCCESS'));
        _loadInitialData();
        _hideOfferSummaryIfSameOpen(campaignId);
        cancelModal();
        cancelSummaryModal();
      }).catch(utils.errorHandler);
    }

    function showOffer(campaign) {
      if (!vm.formActive && campaign.offer && campaign.offerHidden) {
        return offersService.unhideCampaignOffer(accountsService.currentAccountId, campaign.id).then(function() {
          toaster.pop('success', $translate.instant('CONFIRM_SHOW_SUCCESS'));
          _loadInitialData();
        }).catch(utils.errorHandler);
      }
    }

    function handleOfferFilterChange(filterSelected) {
      vm.showAllOffers = filterIncludeHidden[filterSelected];
      _loadInitialData();
    }

    function setForceUnlink(value) {
      vm.forceUnlink = value;
    }

    function getRtbStatus(campaign) {
      if (!campaign.enabled) {
        return 'OFF';
      }

      if (!campaign.rtb) {
        return 'OFF';
      }

      return campaign.rtb.enabled ? 'ON' : 'OFF';
    }

    function getRtbStatusToolTip(campaign) {
      if (!campaign.enabled) {
        return 'CAMPAIGN_PAUSED_RTB_ADMIN';
      }

      if (!campaign.rtb) {
        return 'CAMPAIGN_PAUSED_RTB_ADMIN';
      }

      return campaign.rtb.enabled ? 'CAMPAIGN_LIVE_RTB_ADMIN' : 'CAMPAIGN_PAUSED_RTB_ADMIN';
    }

    function _checkCampaignReferences(campaignId) {
      vm.campaignReferences = null;
      vm.checkReferencesText = 'DELETE_CAMPAIGN_MODAL_CAMPAIGN_CHECK_ASSOCIATION_TEXT';
      bsLoadingOverlayService.start();
      campaignServiceNew.checkCampaignReferences(accountsService.currentAccountId, campaignId).then(function (response) {
        $timeout(function () {
          bsLoadingOverlayService.stop();
          vm.campaignReferences = response.data;
        }, 800);
      }).catch(function () {
        bsLoadingOverlayService.stop();
        vm.checkReferencesText = 'DELETE_CAMPAIGN_MODAL_CAMPAIGN_CHECK_ASSOCIATION_TEXT_ERROR';
      });
    }

    function _loadUserSettings() {
      return userSettingsService.getUserSettings()
        .then(function (userSettings){
          vm.userSettings = userSettings;
          vm.columns = columnsFetchService.getColumnList(userSettings, campaignServiceNew.defaultColumns, 'campaigns', vm.columnSettings);
        })
        .catch(utils.errorHandler);
    }

    function _loadCampaigns() {
      return campaignServiceNew.getCampaigns(accountsService.currentAccountId, true, featureFlags.isOn('rtb'), true)
        .then(function(response) {
          vm.currentCampaigns = response.data.campaigns;
          _.assign(vm.displayCampaigns, response.data.campaigns);

          _updateStats(response.data.stats);

          _updateRtbStats(response.data['rtb']);

          if (!vm.isAffiliate) {
            _stopLoading();
          }

          if (!statsInterval) {
            _setStatsInterval();
          }
        });
    }

    function _setStatsInterval() {
      statsInterval = $interval(function () {
        campaignServiceNew.getCampaignsStats(accountsService.currentAccountId)
          .then(function (response) {
            _updateStats(response.data.stats);
          })
          .catch(utils.errorHandler);
      }, 15000);
    }

    function _updateStats(stats) {
      const updatedCampaignStats = _normalizeStats(stats);

      vm.currentCampaigns.forEach(function (campaign) {
        _.assign(campaign, updatedCampaignStats[campaign.id] || emptyStats);
      });
    }

    function _updateRtbStats(rtbStats) {
      if (!rtbStats || rtbStats.length < 1) {
        return;
      }

      const updatedCampaignRtbStats = _normalizeRtbSettings(rtbStats);

      if (vm.isAffiliate) {
        vm.displayCampaigns.forEach(function (campaign) {
          if (updatedCampaignRtbStats[campaign.id]) {
            _.assign(campaign, { rtb: { setup: updatedCampaignRtbStats[campaign.id].setup, enabled: updatedCampaignRtbStats[campaign.id].enabled } });
          }
        });
      } else {
        vm.currentCampaigns.forEach(function (campaign) {
          if (updatedCampaignRtbStats[campaign.id]) {
            _.assign(campaign, { rtb: { setup: updatedCampaignRtbStats[campaign.id].setup, enabled: updatedCampaignRtbStats[campaign.id].enabled } });
          }
        });
      }
    }

    function _loadAllOffers() {
      if (vm.isAffiliateManager) {
        return _getDisplayDataReady([], {});
      }

      return offersService.getAllOffers(accountsService.currentAccountId, vm.showAllOffers).then(function(response) {
        const hiddenOfferCampaignIds = _.reduce(response.data.hiddenOfferCampaignIds, function (obj, id) {
          obj[id] = true;
          return obj;
        }, {});

        _getDisplayDataReady(response.data.offers, hiddenOfferCampaignIds);

        if (vm.isAffiliate) {
          _updateRtbStats(response.data['rtb']);
        }
      }).catch(function() {
        _getDisplayDataReady([], {});
      });
    }

    function _getDisplayDataReady(offers, hiddenOfferCampaignIds) {
      _setCampaignOffers(offers, hiddenOfferCampaignIds);
      _stopLoading();

      if (vm.isAffiliate && vm.currentCampaigns.length === 0) {
        vm.hideAffiliateCampaigns = true;
      }
    }

    function _normalizeStats(stats) {
      const updatedCampaignStats = {};
      if (!_.isEmpty(stats)) {
        _.forOwn(stats, function(value, key) {
          const upperFirstLetterkey = key.charAt(0).toUpperCase() + key.slice(1);
          updatedCampaignStats[upperFirstLetterkey] = value;
        });
      } else {
        _.forEach(vm.currentCampaigns, function(campaign) {
          updatedCampaignStats[campaign.id] = angular.copy(emptyStats);
        });
      }
      return updatedCampaignStats;
    }

    function _normalizeRtbSettings(rtbRawSettings) {
      const rtbSettings = {};
      rtbRawSettings.forEach(function (rrs) {
        rtbSettings[rrs.campaignId] = {
          setup: rrs.setup,
          enabled: rrs.enabled
        };
      });
      const updatedCampaignStats = {};
      if (!_.isEmpty(rtbSettings)) {
        _.forOwn(rtbSettings, function(value, key) {
          const upperFirstLetterkey = key.charAt(0).toUpperCase() + key.slice(1);
          updatedCampaignStats[upperFirstLetterkey] = value;
        });
      } else {
        _.forEach(vm.currentCampaigns, function(campaign) {
          updatedCampaignStats[campaign.id] = angular.copy(emptyStats);
        });
      }
      return updatedCampaignStats;
    }

    function _loadInitialData() {
      vm.loading = true;
      vm.hideAffiliateCampaigns = false;
      vm.currentCampaigns = [];
      bsLoadingOverlayService.start();
      $interval.cancel(statsInterval);
      statsInterval = null;

      if (vm.showSpecificRecordDetails) {
        _getDisplayDataReady([], {});
      } else {
        $timeout(function () {
          return _loadCampaigns().then(_loadAllOffers);
        }, 0);
      }
    }

    function _setCampaignOffers(offers, hiddenOfferCampaignIds) {
      const mapCampaignByid = _.keyBy(vm.currentCampaigns, 'id');

      _.forEach(offers, function(offer) {
        const campaign = mapCampaignByid[offer.campaignId];

        if (campaign) {
          campaign.offer = offer;
          campaign.offerHidden = hiddenOfferCampaignIds && !!hiddenOfferCampaignIds[campaign.id];
        } else {
          const mockCampaign = _getMockCampaignForOffer(offer, hiddenOfferCampaignIds);
          vm.currentCampaigns.push(_.assign(mockCampaign, emptyStats));
        }
      });

      _populateCombinedStatus(vm.currentCampaigns, vm.isAffiliate);
      // apparently smart table does not monitor changes to st-safe-src unless
      // there is an insertion/deletion of rows or complete reassignment
      $scope.$broadcast('refreshCampaigns');
    }

    // This would add combinedStatus property to each campaign
    function _populateCombinedStatus(campaigns, isAffiliate) {
      _.forEach(campaigns, function (campaign) {
        campaign.combinedStatus = campaignServiceNew.getCampaignStatus(campaign, isAffiliate);
      });
    }

    function _getMockCampaignForOffer(offer, hiddenOfferCampaignIds) {
      return {
        id: offer.campaignId,
        name: offer.campaignName,
        countryCode: offer.countryCode,
        offer: offer,
        completed: true,
        enabled: true,
        offerHidden: hiddenOfferCampaignIds && !!hiddenOfferCampaignIds[offer.campaignId]
      };
    }

    function _checkIfUserIsEnrolled(offer) {
      return offer && offer.offerParticipationStatus === 'enrolled';
    }

    function _checkIfUserCanParticipate(campaign) {
      return campaign.offer && (!campaign.offer.participationStatus || (campaign.offer.offerParticipationStatus !== 'enrolled' && campaign.offer.offerParticipationStatus !== 'pending'));
    }

    function _hideOfferSummaryIfSameOpen(campaignId) {
      if (vm.activeCampaignOfferSummary === campaignId) {
        vm.activeCampaignOfferSummary = null;
      }
    }

    function _stopLoading() {
      vm.loading = false;
      bsLoadingOverlayService.stop();
    }

    function _getParticipateOfferTranslation(offer, applyTranslation, joinTranslation) {
      return offer && (offer.offerParticipationStatus === 'available-with-approval' || offer.offerParticipationStatus === 'declined') ? applyTranslation : joinTranslation;
    }

    function showAddNewForm() {
      vm.showCampaignWizard = true;
      vm.formActive = true;
    }

    function showForm(campaign, force) {
      if (!vm.formActive || force) {
        if (campaign) {
          campaign.showEditForm = true;
        } else {
          vm.showCampaignWizard = true;
        }
        vm.activeActioncampaignId = false;
        vm.formActive = true;
      }
    }

    function hideForm(campaign) {
      if (campaign) {
        campaign.showEditForm = false;
      } else {
        vm.showCampaignWizard = false;
      }
      vm.formActive = false;

      if (vm.showSpecificRecordDetails || vm.isWizardRoute) {
        $state.go('dashboard.campaigns');
      }
    }

    function _setViewDetails(showSpecificRecordDetails) {
      if (vm.isWizardRoute) {
        _setTrMetadata(wizardTrWidgetMetadata);
        showAddNewForm();
        return;
      }

      let loadingTranslation = 'CAMPAIGNS_HEADER_LOADING';
      if (showSpecificRecordDetails) {
        loadingTranslation = 'CAMPAIGN_HEADER_LOADING';
      } else {
        _setTrMetadata(defaultTrWidgetMetadata);
      }

      $translate(loadingTranslation).then(function (translation) {
        vm.loadingText = translation;
      });
    }

    function _setTrMetadata(metadata) {
      $translate(metadata.title).then(function (translation) {
        vm.widgetTitle = translation;
      });

      vm.widgetIcon = metadata.iconClass;
      vm.widgetClass = metadata.class;
    }

    // When the DOM element is removed from the page,
    // AngularJS will trigger the $destroy event on
    // the scope. This gives us a chance to cancel any
    // pending timer that we may have.
    $scope.$on(
      '$destroy',
      function () {
        $interval.cancel(statsInterval);
      }
    );
  }
})();
